<template>
	<div style="height: 100%;">
		<div class=" h100 flex-column">
			<div class="flex-reverse items-center">
				<!-- <a-input-search size="small" allowClear @search="goSearchProjectMembers" v-model="searchInput" placeholder="搜索关键字..." style="width: 250px" enter-button @pressEnter="goSearchProjectMembers" /> -->
				<!-- <a-button size="small" type="primary" class="mr10" @click="addTransfer(0)">发起人员调动</a-button> -->
			</div>
			
			<div class="flex flex-height mt10">
				<div class="h100 flex-column" style="width: 300px; padding-top: 10px;background-color: white;border-radius: 20px;">
                    <a-menu
                        class="flex-height scroll"
                        :default-selected-keys="['0']"
                        :default-open-keys="['0']"
                        mode="inline"
                    >
                        <a-menu-item :key="item.id" v-for="item in projects" @click="handleClick(item)">
                            <a-icon type="right-square" />
                            {{item.name}}
                        </a-menu-item>
                    </a-menu>
				</div>
				<div class="flex-column flex-width h100 ml15">
                    <a-card :bordered="false" class="h100" :bodyStyle="{paddingTop: 0, paddingBottom: '16px' }">
                        <template #title class="" style="">
                            <div class="flex items-center" style="justify-content: space-between;">
                                <h6 class="font-semibold m-0 flex">项目成员<div>({{ selectProject }})</div></h6>
                                <a-input-search allowClear style="width:300px" v-model="search" placeholder="请输入关键字" enter-button @change="allowCostClear" @search="getProjectMembers" @pressEnter="getProjectMembers"/>
                            </div>
                        </template>
                        <div
                            v-infinite-scroll="handleInfiniteOnLoad"
                            class="demo-infinite-container"
                            :infinite-scroll-disabled="busy"
                            :infinite-scroll-distance="10"
                        >
                            <a-list 
                                class="conversations-list"
                                item-layout="horizontal"
                                :split="true"
                                :data-source="projectMembers"
                                
                            >
                                <a-list-item slot="renderItem" slot-scope="item">
                                    <div slot="actions">
                                        <div class="flex items-center">
                                            <div class="mr20">
                                                联系电话： {{item.phone}}
                                            </div>
                                            <div v-if="item.status==1" class="fs12" style="color:lightcoral">(项目调动审批中)</div>
                                       
                                            <a-popconfirm
												title="确认取消调动申请?"
												ok-text="是"
												cancel-text="否"
												@confirm="deleteTransfer(item)"
											>
                                                <a-button v-if="item.status==1" type="link" style="color:red" icon="close">
                                                    取消
                                                </a-button>
											</a-popconfirm>
                                            <a-button v-if="item.status==0" type="link" icon="retweet" @click="addTransfer(item.id)">
                                                人员调动
                                            </a-button>
                                            
                                        </div>
                                    </div>
                                    
                                    <a-list-item-meta
                                        :title="item.name"
                                        :description="item.type_name"
                                    >   
                                    <div  slot="avatar" class="pd10">
                                        <a-avatar
                                           
                                            :size="60"
                                            shape="square"
                                            src="images/headimg.jpg"
                                        />
                                    </div>
                                        
                                    </a-list-item-meta>
                                </a-list-item>
                            </a-list>
                        </div>
                    </a-card>
				</div>
               
			</div>
		</div>
        <a-modal
			title="人员资料"
			:visible="visibleDetail"
			@cancel="visibleDetail=false"
			:width="800"
			:footer="null"
		>
			<div class="flex items-center">
				<a-avatar :src="personalDetail.data.headimg" />
				<div class="ml10">{{ personalDetail.data.name }}</div>
			</div>
			<div>
				<a-divider/>
				<div class="">
					<div class="fs13 bold a90">个人资料</div>
					<div class="flex">
						<div class="flex-width">
							<div class="flex mt10" style="color: gray;">
								姓名：
								<div class="ml10">{{ personalDetail.data.name }}</div>
							</div>
							<div class="flex mt10" style="color: gray;">
								电话：
								<div class="ml10">{{ personalDetail.data.phone }}</div>
							</div>
						</div>
						<div class="flex-width">
							<div class="flex mt10" style="color: gray;">
								部门：
								<div class="ml10">{{ personalDetail.data.depart }}</div>
							</div>
							<div class="flex mt10" style="color: gray;">
								当前项目：
								<div class="ml10">{{ personalDetail.data.project }}</div>
							</div>
						</div>
					</div>
					
				</div>
				<a-divider/>
			</div>
		</a-modal>
        <a-modal
            title="新增人员调动·默认业务类型"
			:visible="visible"
			@cancel="visible=false"
            @ok="goAddNewTransfer"
            okText="确定"
            cancelText="取消"
			:width="800"
		>
			<div class="flex items-center">
				<a-avatar :src="personalDetail.data.headimg" />
				<div class="ml10">{{ personalDetail.data.name }}</div>
			</div>
			<div>
				<a-divider/>
				<div class="">
					<div class="fs14 bold a90">个人资料</div>
                    <a-row :gutter="16" class="">
                        <a-col :span="8">
                            <div class="flex mt10" style="color: gray;">
								姓名：
								<div class="ml10" style="font-weight: bolder;">{{ personalDetail.data.name }}</div>
							</div>
                        </a-col>
                        <a-col :span="8">
                            <div class="flex mt10" style="color: gray;">
								电话：
								<div class="ml10" style="font-weight: bolder;">{{ personalDetail.data.phone }}</div>
							</div>
                        </a-col>
                        <a-col :span="8">
                            <div class="flex mt10" style="color: gray;">
								部门：
								<div class="ml10" style="font-weight: bolder;">{{ personalDetail.data.depart }}</div>
							</div>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" class="">
                        <a-col :span="8">
                            <div class="flex mt10" style="color: gray;">
								当前项目：
								<div class="ml10" style="font-weight: bolder;">{{ personalDetail.data.project }}</div>
							</div>
                        </a-col>
                        <a-col :span="8">
                            <div class="flex mt10" style="color: gray;">
								项目职位：
								<div class="ml10" style="font-weight: bolder;">{{ personalDetail.data.type_name }}</div>
							</div>
                        </a-col>
                    </a-row>
					
				</div>
				<a-divider/>
                <a-row :gutter="16" class="">
                    <a-col :span="12">
                        <div class="fs13 bold a90">请选择调入项目</div>
                        <a-select
                            show-search
                            v-model="select_to_project_id"
                            option-filter-prop="children"
                            :filter-option="filterOption"
                            class="mt10"
                            style="width: 300px"
                            placeholder="请选择调入项目"
                            size="small"
                            @change="updateSelectProject()"
                        > 
                        <a-select-option v-for="item in (memberProjects.filter(it=>it.id != personalDetail.data.project_id))" :key="item.key" :value="item.id">
                            {{ item.name }} —— {{ item.create_time.replace("T", " ")}}
                            </a-select-option>
                        </a-select>
                    </a-col>
                    
                    <a-col :span="12">
                        <div class="fs13 bold a90">请选择职位</div>
                        <a-select
                            show-search
                            v-model="select_to_type_id"
                            option-filter-prop="children"
                            :filter-option="filterOption"
                            class="mt10"
                            style="width: 300px"
                            placeholder="请选择职位"
                            size="small"
                            @change="updateSelectType()"
                        > 
                        <a-select-option v-for="item in positionList" :key="item.key" :value="item.id">
                            {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>
                <a-row :gutter="16" class="mt20">
                    <!-- <a-col :span="12">
                        <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{paddingTop: '12px',}">
                            <a-timeline :reverse="timelineReverse">
                                <a-timeline-item color="green">
                                    <div class="flex items-center">
                                        <div class="mr10">审批人:</div>
                                        <choose-person-box v-model="personalDetail.approval_person.persons"></choose-person-box>
                                    </div>
                                    <p>调入部门审批人</p>
                                </a-timeline-item>
                                <a-timeline-item color="green">
                                    <div class="flex items-center">
                                        <div class="mr25">抄送:</div>
                                        <choose-person-box v-model="personalDetail.send_person.persons"></choose-person-box>
                                    </div>
                                </a-timeline-item>
                            </a-timeline>
                        </a-card>
                    </a-col> -->
                    <a-col :span="12">
                        <a-form-item  class="fs13 bold a90"  label="备注">
                            <a-textarea
                                v-model="personalDetail.data.note"
                                placeholder="请输入备注"
                                :auto-size="{ minRows: 3, maxRows: 5 }"
                                size="small"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>

               
                
			</div>
		</a-modal>
	</div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll';
import ChoosePersonBox from '../../common/ChoosePersonBox.vue';
const KF = 'updatable';

	export default ({
		components: {
            ChoosePersonBox
        },
        directives: { infiniteScroll },
		data() {
			return {
                projectMembers:[
                    // {uid:1,key:1, name:"特朗普", type_name:"销售总监", headimg:"images/face-1.jpg"},{uid:2, key:2, name:"拜登", type_name:"区域经理", headimg:"images/face-2.jpg"},{uid:3, key:3, name:"马克龙", type_name:"技术", headimg:"images/face-3.jpg"},{uid:4, key:4, name:"泽连斯基", type_name:"资料员", headimg:"images/face-4.jpg"},{uid:5, key:5, name:"普京", type_name:"收料员", headimg:"images/face-5.jpeg"},{uid:6, key:6, name:"伊丽莎白", type_name:"商务经理", headimg:"images/face-6.jpeg"}, {uid:7, key:7, name:"普京", type_name:"收料员", headimg:"images/face-5.jpeg"},{uid:8, key:8, name:"伊丽莎白", type_name:"商务经理", headimg:"images/face-6.jpeg"}
                ],
                projects:[],
                memberProjects:[], //可调入的项目
				positionList:[{id:1, key:1, name:"项目经理"}, {id:2, key:2, name:"收料员"}, {id:3, key:3, name:"采购员"}, {id:4, key:4, name:"财务"}, {id:5, key:5, name:"仓管"}, {id:6, key:6, name:"区域经理"}, {id:7, key:7, name:"生产经理"}, {id:8, key:8, name:"技术"}, {id:9, key:9, name:"安全主管"}, {id:10, key:10, name:"资料员"}, {id:11, key:11, name:"成本"}],               
                selectProject:"",
                loading: false,
                busy: false,
                personalDetail:{event_type: 13,data:{name:"", uid:0, headimg:"",phone:"", depart:"", project:"", project_id:0, to_project:"请选择调入项目", to_project_id:0, type:0, tpye_name:"", to_type_id:0, to_type_name:"请选择职位"}, approval_person:{flow_type:1, persons:[]},send_person:{flow_type:2, persons:[]},person:[] },
                visibleDetail:false,
                visible:false,
				timelineReverse: false,
                formItemLayout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 18 },
                },
                select_to_project_id:"",
                select_to_type_id:"",
                search:"",
                click_project_id:0,
                flowdata:[],
			}
		},
		async created() {
			this.getProjects()
		},
		methods:{
            async getProjects(){
                let rs = await this.$api.getProjectList()
                if(rs.err == 0){
                    this.selectProject = rs.data[0].name
                    this.click_project_id = rs.data[0].id
                    this.projects = rs.data
                    this.getProjectMembers()
                }
            },
            async getWithoutMemberProjects(key){
                let rs = await this.$api.getWithoutMemberProjects(key)
                if(rs.err == 0){
                    this.memberProjects = rs.data
                }
            },
            async getProjectMembers(){
                let rs = await this.$api.getSelectProjectMembers(this.click_project_id, this.search)
                if(rs.err == 0){
                    this.projectMembers = rs.data
                }
            },
            handleClick(item){
                this.selectProject = item.name
                this.click_project_id = item.id
                this.getProjectMembers()
            },
            handleInfiniteOnLoad() {
                const data = this.projectMembers;
                this.loading = true;
                if (data.length > 14) {
                    // this.$message.warning('Infinite List loaded all');
                    this.busy = true;
                    this.loading = false;
                    return;
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            updateSelectProject(){
                let part = this.projects.find(it=>it.id == this.select_to_project_id)
                this.personalDetail.data.to_project_id = part.id
                this.personalDetail.data.to_project = part.name
            },
            updateSelectType(){
                let part = this.positionList.find(it=>it.id == this.select_to_type_id)
                this.personalDetail.data.to_type_id = part.id
                this.personalDetail.data.to_type_name = part.name
            },
            addTransfer(key){
                if(key == 0){
                    this.personalDetail = {event_type: 13, data:{name:"", id:0, uid:0, headimg:"",phone:"", depart:"", project:"", project_id:0, to_project:"请选择调入项目", to_project_id:0,type:0, tpye_name:"", to_type_id:0, to_type_name:""}, approval_person :{flow_type:1, persons:[]},send_person:{flow_type:2, persons:[]},person:[] }
                    visibleDetail = true
                }else{
                 
                    
                    this.select_to_project_id = ""
                    this.select_to_type_id = ""

                    this.personalDetail.data = this.projectMembers.find(it=>it.id == key)
                    this.personalDetail.data.note = ""
                    this.personalDetail.data.to_project_id = ""
                    this.personalDetail.data.to_project = "请选择调入项目"
                    this.personalDetail.data.to_type_id = ""
                    this.personalDetail.data.to_type_name = "请选择职位"
                    this.personalDetail.approval_person = {flow_type:1, persons:[]},
                    this.personalDetail.send_person = {flow_type:2, persons:[]},
                    this.personalDetail.person = []
                    this.visible = true
                    this.getWithoutMemberProjects(this.personalDetail.data.uid)
                    this.getProjectFlow()
                }
            },
            check(){
                if(this.personalDetail.data.to_type_id == ""){
                    this.$notification['warning']({
                        message: '未选择职位',
                        style: {
                            width: '600px',
                            marginLeft: `${335 - 600}px`,
                        },
                    });
                    return;
                }
                if(this.personalDetail.data.to_project_id == ""){
                    this.$notification['warning']({
                        message: '未选择调入项目',
                        style: {
                            width: '600px',
                            marginLeft: `${335 - 600}px`,
                        },
                    });
                    return;
                }
                // if(this.personalDetail.approval_person.persons.length == 0){
                //     this.$notification['warning']({
                //         message: '未选择审批人员',
                //         style: {
                //             width: '600px',
                //             marginLeft: `${335 - 600}px`,
                //         },
                //     });
                //     return false;
                // }
                return true;
            },
            async goAddNewTransfer(){
                if(!this.check()){
                    return;
                }
                // this.personalDetail.person = [{flow_type:1, persons:[]}, {flow_type:2, persons:[]}]
                // let part1 = this.personalDetail.person.find(it=>it.flow_type == 1)
                // part1.persons = this.personalDetail.approval_person.persons
                // let part2 = this.personalDetail.person.find(it=>it.flow_type == 2)
                // part2.persons = this.personalDetail.send_person.persons
                let data = [];
                for (let item of this.flowdata) {
					let vo = {
						flow_type: item.flow_type,
						persons: []
					}
					if (item.approver_uid != 0) {
						vo.persons.push(item.approver_uid);
					}
					if (item.persons.length > 0) {
						for (let p of item.persons) {
							vo.persons.push(p.user_id);
						}
					}
					data.push(vo);
				}
				this.personalDetail.person = data;
                let rs = await this.$api.goAddPersonnelTransfer(this.personalDetail)
                if(rs.err == 0){
                    // this.$message.loading({ content: '正在保存中...', KF })
                    this.$message.success('提交成功，请等待审批')
                    this.visible = false
                    this.getProjectMembers()
                }else{
                    // this.$message.loading({ content: '正在保存中...', KF })
                    this.$message.warn('保存失败，请检查后重试或联系管理员')
                }
            },
            allowCostClear(){

            },
            async deleteTransfer(item){
                let rs = await this.$api.deletePersonnalTransfer(item.id, item.flow_apply_id)
                if(rs.err == 0){
                    this.$message.success(`操作成功`);
                    this.getProjectMembers()
				} else {
					this.$message.error(`操作失败，请重试或联系管理员`);
                }
            },
            async getProjectFlow() {
				let rs = await this.$api.getCompanyProjectFlow(13);
				if (rs.err == 0) {
					for (let item of rs.data.flowdata) {
						if (item.persons == null) {
							item.persons = [];
						}
					}
					this.flowdata = rs.data.flowdata;
				}
			},


		}
	})
</script>

<style>
.row-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.demo-infinite-container {
  border-radius: 4px;
  overflow: auto;
  padding: 8px 24px;
  height: 550px;
}
.demo-loading-container {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
}
</style>